import { useLocation } from "react-router-dom";

function PatientProfilePrint() {
  const query = new URLSearchParams(useLocation().search);
  const fileUrl = query.get("file");

  return (
    <iframe
      src={fileUrl}
      title="Patient PDF"
      width="100%"
      height="100%"
      style={{ border: "none" }}
    />
  );
}

export default PatientProfilePrint;